import { useSelector } from "react-redux";

/**
 * Resolves the customer segment from a user object that may come
 * from login payload, Google auth, or profile response.
 * Returns 1 for business, 0 for retail / guest.
 */
const resolveUserType = (u) => {
  // Accept numeric or string forms from different API shapes
  const raw = u?.userType ?? u?.user_type ?? u?.customerSegment ?? null;
  if (raw === null || raw === undefined) return 0;
  return Number(raw) === 1 ? 1 : 0;
};

const useAuth = () => {
  const user = useSelector((state) => state.user);

  // Check if user is logged in
  const isAuthenticated = !!user?.user?.token;

  // true when the logged-in user is a business (B2B) customer
  const userType = resolveUserType(user?.user);
  const isBusiness = userType === 1;

  return { user, isAuthenticated, isBusiness, userType };
};

export default useAuth;
